import Joi from '@hapi/joi'

export const goodsReceivedNoteSchemaObject = {

    // groupID: Joi.number().invalid(0).required().label("Group *").messages({
    //     "any.invalid": `Group Name Required`,
    // }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity  Name *").messages({
        "any.invalid": `Operation Entity  name is required`,
    }),

    dateID: Joi.string().invalid().required().label("Date").messages({
        "any.invalid": `Date Required`,
        "any.required": `Date Required`
    }),

}

